module.exports = "/images/modul_sobat_upah_with_text-c02b6d7b319bf410dd4e48ed3d3d43ca.png";